import { forwardRef, UIEvent, useCallback, useEffect, useRef } from 'react'

import * as Styled from './styles'

interface StickyScrollbarProps {
  hasHorizontalOverflow: boolean
  onScroll: (scrollLeft: number) => void
  tableScrollLeft: number
  tableScrollWidth: number
  isScrollbarSticky?: boolean
}

export const StickyScrollbar = forwardRef<HTMLDivElement, StickyScrollbarProps>(
  ({ hasHorizontalOverflow, onScroll, tableScrollLeft, tableScrollWidth, isScrollbarSticky = false }, ref) => {
    const isScrollingRef = useRef(false)

    const handleScrollbarScroll = useCallback(
      (event: UIEvent<HTMLDivElement>) => {
        if (isScrollingRef.current) {
          return
        }

        const target = event.currentTarget
        const scrollLeft = target.scrollLeft

        onScroll(scrollLeft)
      },
      [onScroll],
    )

    useEffect(() => {
      if (ref && typeof ref === 'object' && ref?.current && !isScrollingRef.current) {
        isScrollingRef.current = true
        ref.current.scrollLeft = tableScrollLeft

        setTimeout(() => {
          isScrollingRef.current = false
        }, 0)
      }
    }, [tableScrollLeft, ref])

    if (!hasHorizontalOverflow) {
      return null
    }

    return (
      <Styled.StickyScrollbarContainer ref={ref} onScroll={handleScrollbarScroll} isSticky={isScrollbarSticky}>
        <Styled.ScrollbarTrack width={tableScrollWidth} />
      </Styled.StickyScrollbarContainer>
    )
  },
)
